/**
 * Move the Wishlist-by-Square header heart into header-actions
 * so it participates in the same flex/grid as account + cart.
 */
function placeWishlistInHeaderActions(wishlist) {
  const headerActions = document.querySelector(
    '.header__column--right header-actions, header-actions'
  );

  if (!headerActions || headerActions.contains(wishlist)) return;

  headerActions.prepend(wishlist);
  wishlist.classList.add('header-actions__action', 'header-actions__wishlist');
}

function initWishlistHeaderPlacement() {
  const existing = document.querySelector('.Vtl-WishlistHeaderWrapper');
  if (existing) {
    placeWishlistInHeaderActions(existing);
  }

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof HTMLElement)) continue;

        const wishlist =
          node.matches?.('.Vtl-WishlistHeaderWrapper')
            ? node
            : node.querySelector?.('.Vtl-WishlistHeaderWrapper');

        if (wishlist) {
          placeWishlistInHeaderActions(wishlist);
        }
      }
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initWishlistHeaderPlacement, {
    once: true,
  });
} else {
  initWishlistHeaderPlacement();
}
